import Component from '@glimmer/component';

import { registerDestructor } from '@ember/destroyable';
import { service } from '@ember/service';
import { cached, tracked } from '@glimmer/tracking';

/**
 * Disallow focused element outlines with mouse events; allow with keyboard events.
 */
export default class extends Component {
  @service ssr;

  @tracked
  isKeysActive = false;

  @cached
  get keysInactiveStyle() {
    return this.args.keysInactiveStyle
      ?? ':focus{outline:0}::-moz-focus-inner{border:0}';
  }
  @cached
  get keysActiveStyle() {
    return this.args.keysActiveStyle ?? '';
  }
  @cached
  get style() {
    return this.isKeysActive ? this.keysActiveStyle : this.keysInactiveStyle;
  }

  constructor() {
    super(...arguments);

    if (this.ssr.isSsr) {
      return;
    }

    const onPointerActive = () => {
      if (this.isKeysActive) {
        this.isKeysActive = false;
      }
    };
    const onKeysActive = () => {
      if (!this.isKeysActive) {
        this.isKeysActive = true;
      }
    };

    const mouseEvents = [ 'mousedown', 'touchstart', 'wheel', 'drag' ];
    const keyboardEvents = [ 'keydown' ];

    mouseEvents.forEach(e => {
      document.addEventListener(e, onPointerActive);
      registerDestructor(this, () => document.removeEventListener(e, onPointerActive));
    });
    keyboardEvents.forEach(e => {
      document.addEventListener(e, onKeysActive);
      registerDestructor(this, () => document.removeEventListener(e, onKeysActive));
    });
  }

  <template>
    {{!--template-lint-disable no-forbidden-elements--}}
    <style>{{this.style}}</style>
  </template>
}
